import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: (props: any) => ({
    color: "black",
    // margin: theme.spacing(1),
    fontSize: '18px',
    '& PrivateRadioButtonIcon': {
      color: props.darkColor
    }
  }),
  radio: (props: any) => ({
    color: `${props.darkColor} !important`,
    '&$checked': {
      color: `${props.darkColor} !important`
    }
  }),
  checked: {},
  formControlLabel: {
    fontSize: '18px'
  },
  formControlLabelRoot: {
    color: '#000000 !important'
  }
}));

const RadioInput = (props: any) => {
  const classes = useStyles(props);
  // console.log(props)
  const { label, value, setValue, name, inputs, darkColor } = props;

  return (
    <FormControl component="fieldset" className={classes.root}>
      <RadioGroup
        aria-label={name}
        name={name}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      // row
      >
        {inputs.map((x: any, index: any) => {
          return (
            <FormControlLabel
              key={index}
              value={x}
              control={<Radio classes={{ root: classes.radio, checked: classes.checked }} checked={(x == value)} />}
              label={x}
              classes={{ root: classes.formControlLabelRoot, label: classes.formControlLabel }}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioInput;